var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`alert modal-alert-${_vm.color} text-left`},[_c('ol',_vm._l((this.itemList),function(value,index){return _c('li',{key:index},[(_vm.$scopedSlots['item-content'])?_c('span',[_vm._t("item-content",null,{"item":value})],2):_c('span',[_vm._v(" "+_vm._s(value)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }